import { render, staticRenderFns } from "./AddToFavorites.vue?vue&type=template&id=c553f364&scoped=true&"
import script from "./AddToFavorites.vue?vue&type=script&lang=js&"
export * from "./AddToFavorites.vue?vue&type=script&lang=js&"
import style0 from "./AddToFavorites.vue?vue&type=style&index=0&id=c553f364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c553f364",
  null
  
)

export default component.exports